import { IApiQueryResponse } from '@llws/api-common';
import { IPartners } from '@llws/lift-entity-interfaces';
import { dispatch } from '../../store';
import { partnersListReceived, morePartnersReceived } from './partnersSlice';
import { store } from '../../store';
import { keys } from '@jamesgmarks/utilities';
import { apiFetch } from '../../utils';
import { REACT_APP_API_ROOT_URI } from '../../../App';

const getFilterQueryStringItems = () => {
  const filters = store.getState().partners.filters || {};
  const queryString = filters ? `?${keys(filters).map(f => `${f}=${filters[f]}`).join('&')}` : '';
  return queryString;
};

export const loadPartners = async () => {
  const queryString = getFilterQueryStringItems();
  const url = `${REACT_APP_API_ROOT_URI}/rentsync/partners${queryString}`;
  const response = await apiFetch(url);
  const responseData = await response.json() as IApiQueryResponse<IPartners>;
  dispatch(partnersListReceived(responseData)); // TODO: Error handling?
};

export const loadMorePartners = async () => {
  const queryString = getFilterQueryStringItems();
  const url = `${REACT_APP_API_ROOT_URI}${store.getState().partners.nextPage}${queryString}`;
  const response = await apiFetch(url);
  const responseData = await response.json() as IApiQueryResponse<IPartners>;
  dispatch(morePartnersReceived(responseData)); // TODO: Error handling?
};
